import React from 'react';
import { MotionConfig } from 'motion/react';

/**
 * App-wide motion configuration.
 *
 * `reducedMotion="user"` makes Motion read `prefers-reduced-motion: reduce`
 * from the OS and automatically:
 *   - skip transform animations (x/y/scale/rotate)
 *   - skip opacity animations
 *   - keep layout animations and other non-vestibular changes intact
 *
 * This satisfies WCAG 2.1 SC 2.3.3 (Animation from Interactions) for every
 * `<motion.*>` component in the tree without each consumer having to branch
 * on `useReducedMotion()`.
 *
 * CSS-driven animations (Tailwind animate, keyframes in `index.scss`) are
 * handled by the `@media (prefers-reduced-motion: reduce)` block in
 * `src/styles/index.scss`.
 */
export const MotionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <MotionConfig reducedMotion="user">{children}</MotionConfig>;
